import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import basicReducer from 'src/reducers/basicReducer';

export const store = configureStore({
  reducer: {
    basic: basicReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
